import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useRecoilValue } from 'recoil';
import Back from "shared/assets/images/svg/back_blue.svg";
import openIcon from 'shared/assets/images/svg/external_arrow.svg'
import useModal from 'shared/hooks/useModel';
import BoxControl from './component/box-control';
import BookingModal from './component/popUp/bookingModal';
import { BookingOfficeSourceAtom } from './component/popUp/office-booking.service';
import { useControlledOffices } from './controlled-offices.service';
const ControlledOffices = () => {
    const {controlledOffices,isSuccess,totalCount} =useControlledOffices()

    return (
        <div className='controlledOffices'>
            <div className='container'>
                <div className="header">
                    <div className="page-name">
                        <Link className="linkBack" to="/">
                            <img src={Back} alt="back" />
                        </Link>
                        <h1>Controlled Offices</h1>
                    </div>
                </div>
                <hr className='hr/' />

              {
              ( isSuccess && totalCount > 0) &&  controlledOffices.map(c=> <BoxControl item={c}   key={c.id}/>)
              }
            </div>

        </div>
    )
}

export default ControlledOffices